<template>
  <div style="width:100%">
    <div class="top-btn-danju">
      <div>
        <el-select v-model="select1_value" size="small" placeholder="请选择">
          <el-option
            v-for="item in column1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <el-select v-model="select2_value" size="small" placeholder="请选择">
          <el-option
            v-for="item in column2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-input
        size="small"
        placeholder="模糊查询"
        v-model="search_value"
        class="input-with-select"
      >
        <el-button
          slot="append"
          type="primary"
          icon="el-icon-search"
          @click="getGoods()"
        ></el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "dyhgoodsSearch",
  data() {
    return {
      list: [],
      column1: [],
      column2: [
        {
          label: "商品名称",
          value: "item_name"
        },
        {
          label: "商品条码",
          value: "barcode"
        },
        {
          label: "建议售价",
          value: "advise_price"
        },
        {
          label: "类别",
          value: "class_no"
        },
        {
          label: "规格",
          value: "item_size"
        },
        {
          label: "品牌",
          value: "brand_name"
        },
        {
          label: "产地",
          value: "product_area"
        },
        {
          label: "单位",
          value: "unit"
        },
        {
          label: "等级",
          value: "grade"
        },
        {
          label: "保质期（天）",
          value: "life_day"
        },
        {
          label: "称重标识",
          value: "weight_flag"
        }
      ],

      search_value: "",
      select1_value: "0",
      select2_value: "item_name"
    };
  },
  watch: {},
  props: {
    who: {
      default: "goodsinfo",
      type: String
    }
  },
  mounted() {
    this.column1 = [];
    const column = [
      {
        label: "正选",
        value: "0"
      },
      {
        label: "反选",
        value: "1"
      },
      {
        label: "全部",
        value: "2"
      },
      {
        label: "新品",
        value: "3"
      },
      {
        label: "老品",
        value: "4"
      }
    ];
    if (this.who == "goodsinfo") {
      this.column1 = column;
    } else if (this.who == "insheet") {
      for (let i = 0; i < 3; i++) {
        this.column1.push(column[i]);
      }
      this.column2 = [];
      this.column2 = [
        {
          label: "商品名称",
          value: "item_name"
        },
        {
          label: "商品条码",
          value: "barcode"
        },
        {
          label: "进价",
          value: "in_price"
        },
        {
          label: "类别",
          value: "class_no"
        }
      ];
    }
  },
  methods: {
    getGoods() {
      this.$emit("getGoods", true);
    },
    search(alls) {
      if (alls == []) return;
      var that = this;
      var all = alls;
      //全部
      if (this.select1_value == "2") {
        this.list = [];
        this.list = all;
        this.$emit("dyhGoodsSearchReturn", this.list);
        return;
      }
      // search_value;
      /**
       * 如果没有搜索值
       */
      if (this.select1_value == "4") {
        var list = [];
        var list = all.filter((item, index) => {
          return item.class_state != "1";
        });
        // this.$emit("dyhGoodsSearchReturn", list);
        all = list;
        // return;
      } else if (this.select1_value == "3") {
        var list = [];
        var list = all.filter((item, index) => {
          return item.class_state == "1";
        });
        /* this.$emit("dyhGoodsSearchReturn", list);
        return; */
        all = list;
      }
      // for (let i = 0; i < all.length; i++) {}
      /* var list0 = all.filter((item, index) => {
          return item[that.select2_value].indexOf(that.search_value) >= 0;
        }); */
      /* console.log("search_value", this.search_value);
      console.log("select1", this.select1_value);
      console.log("select2", this.select2_value); */
      var list0 = [];
      var list1 = [];
      if (this.search_value == "" || this.search_value.length == 0) {
        console.log("search——value");
        //搜索所有存在值 的行
        for (let i = 0; i < all.length; i++) {
          if (
            all[i][that.select2_value] &&
            all[i][that.select2_value].trim() === "" &&
            all[i][that.select2_value].trim().length == 0
          ) {
            list0.push(all[i]);
          }
        }
        console.log("list0", list0);
        //搜索所有不存在值的行
        for (let i = 0; i < all.length; i++) {
          if (
            all[i][that.select2_value] ||
            all[i][that.select2_value].trim() != "" ||
            all[i][that.select2_value].trim().length != 0
          ) {
            list1.push(all[i]);
          }
        }
        console.log("list1", list1);

        /* list1 = all.filter((item, index) => {
          return (
            !item[that.select2_value]||item[that.select2_value].trim() != "" ||item[that.select2_value].trim().length != 0
          );
        }); */

        /* if (this.select1_value == "0"||this.select1_value == "3"||this.select1_value == "4") {
          this.$emit("dyhGoodsSearchReturn", list0);
        } else {
          this.$emit("dyhGoodsSearchReturn", list1);
        } */
      } else {
        //搜索所有存在的值
        for (let i = 0; i < all.length; i++) {
          if (
            all[i][that.select2_value] &&
            all[i][that.select2_value].indexOf(that.search_value) >= 0
          ) {
            list0.push(all[i]);
          }
        }
        //搜索所有不存在的值
        list1 = all.filter((item, index) => {
          return (
            item[that.select2_value] &&
            item[that.select2_value].indexOf(that.search_value) < 0
          );
        });
      }
      if (
        this.select1_value == "0" ||
        this.select1_value == "3" ||
        this.select1_value == "4"
      ) {
        this.$emit("dyhGoodsSearchReturn", list0);
      } else {
        this.$emit("dyhGoodsSearchReturn", list1);
      }
      /* item.item_name.indexOf(that.search_value) >= 0 ||
            String(item.barcode).indexOf(that.search_value) >= 0 */
    }
  }
};
</script>
<style scoped lang="less">
.top-btn-danju {
  display: flex;
  justify-content: left;
  align-items: center;
  height: auto;
  width: 100%;
  padding-left: 10px;
  border-left: 5px solid #ffbb72;
}
/deep/.el-input {
  width: 120px !important;
  max-width: 120px !important;
}
.input-with-select {
  width: 250px;
  min-width: 200px;
}
</style>
